import CIMSFormItem from 'components/CIMSFormItem'
import PayItemSelect from 'components/CIMSSelect/common/PayItemSelect'
import ExternalLinkEditor from 'components/ExternalLinkEditor'
import { Issue } from '../../../../IssueTrackerContext/types'
import { useIssueTrackerContext } from '../../../../IssueTrackerContext'
import { HelpMessage } from 'utils/constants'
import CustomFieldEditor from 'components/CustomFields/CustomFieldEditor'
import { IssueStatus } from 'shared'
import Response from './components/Response'
import IssueTypes from './components/IssueTypes'
import { Description } from './components/Description'
import Reports from './components/Reports'

const EditModalBody: React.FC<Issue> = ({ statusId }) => {
  const help = HelpMessage.Issues.IssueTracker
  const { quickLinkOptions } = useIssueTrackerContext()
  return (
    <>
      <Response statusId={statusId} />
      <IssueTypes statusId={statusId} />
      <Description statusId={statusId} />
      <Reports statusId={statusId} />
      <CIMSFormItem label="Pay Items" name="payItems" help={help.PayItems}>
        <PayItemSelect multiple />
      </CIMSFormItem>
      <CustomFieldEditor
        alreadyDisabled={
          statusId === IssueStatus.Closed.id
            ? { why: 'invalid status', statusName: IssueStatus.Closed.name }
            : false
        }
        hideBooleans
      />
      <ExternalLinkEditor quickLinkOptions={quickLinkOptions} />
    </>
  )
}

export default EditModalBody
